<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>平台运维</el-breadcrumb-item>
          <el-breadcrumb-item>系统日志</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>系统日志</h4>
        <!-- <p @click="addPic">+新增资源库</p> -->
      </div>

      <div class="tablebg"
           v-loading="isRefresh">
        <div style="width:100%;margin:0 auto;">
          <journaltable :tableData="journalTableList"></journaltable>
        </div>

        <div class="pagination">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { journaltable } from "@/components/index";
import { mapActions } from "vuex";
import { listLog } from '@/api/system'
import { getDate, formatConversion } from "@/plugins/getdate";
export default {
  components: {
    journaltable: journaltable
  },
  data () {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      label: ["图库名称", "排序"],
      title: "新增资源库",
      myform: { one: "", two: "" },
      tableDialogFormVisible: false,
      journalTableList: [],
      timeInt: '',
      isRefresh: false
    };
  },
  methods: {


    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val
      let data = { page: (this.currentPage - 1), pageSize: this.pageSize }
      // console.log(data)
      this.listLogAsync(data)
    },


    //刷新表格
    refresh () {

      this.isRefresh = true
      this.handleCurrentChange(this.currentPage);
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },





    //获取图片库列表
    async listLogAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listLog(val);
      if (status) {
        this.journalTableList = data;
        this.total = pagination.total
        for (let i = 0; i < this.journalTableList.length; i++) {
          this.journalTableList[i].createAtMY = formatConversion(this.journalTableList[i].createAt.toString())
          this.journalTableList[i].contentMY = JSON.parse(this.journalTableList[i].content)
          // console.log(this.journalTableList[i].contentMY )
        }
        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    }
  },
  created () {
    this.handleCurrentChange(this.currentPage);

    this.timeInt = setInterval(() => {
      this.handleCurrentChange(this.currentPage);
    }, 90000);
  },
  beforeDestroy () {  // 组件销毁前调用
    clearTimeout(this.timeInt)
  },
  mounted () { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./journalmanage.scss";

h4 {
  font-size: 18px;
}
</style>
